// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__1uyr6","infoBtn":"quickbooks_infoBtn__2WpId","formBox":"quickbooks_formBox__1h2Gt","formFooter":"quickbooks_formFooter__1V0zN"};